import React, {useEffect} from "react";
import {Container} from "react-bootstrap";

const SessionExpired = props => {
  const handleNewQuoteClick = () => {
    window.location.href = '/vehicle';
  };
  const baseUrl = window.location.origin;
  const eventName = window.location.href.includes('car')
    ? 'carAutosureEvent'
    : window.location.href.includes('quashed')
      ? 'carQuashedEvent'
      : window.location.href.includes('better')
        ? 'carBetterEvent'
        : window.location.href.includes('simplify')
          ? 'carSimplifyEvent'
          : '';

  useEffect(() => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': `${eventName}`,
        'category': 'Session Expired',
        'virtualUrl': `${baseUrl}/vehicle/sessionExpired`,
        'pageTitle': 'Session Expired',
      });
  }, []);
    return (
      <>
        <div style={{minHeight: '100vh', display: 'flex', flexDirection: 'column'}}>

          <Container>
            <div style={{textAlign: "center"}}>
              <br/>
              <br/>
              <div className="redMediumTextStyles">Session Expired</div>
              <br/>
              <span style={{display: 'grid', justifyContent: 'center'}}>
                            <br/>
                    <button
                      onClick={handleNewQuoteClick}
                      style={{
                        color: 'white',
                        boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
                        borderRadius: 6,
                        paddingLeft: 25,
                        paddingRight: 25,
                        paddingTop: 13,
                        paddingBottom: 13,
                        overflow: 'hidden',
                        border: '1px white solid',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: "100%",
                        maxWidth: "200px",
                        background: '#1851A3',
                        cursor: 'pointer',
                      }}>Get another quote</button></span>
              <br/><br/><br/><br/>
            </div>

          </Container>
        </div>
      </>

    );
}

export default SessionExpired;
